// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__zvVCj","hero-text-wrapper":"Hero_hero-text-wrapper__zzguA","type":"Hero_type__7zZGX","blink":"Hero_blink__GgrTq","img":"Hero_img__oWQHK"};